// extracted by mini-css-extract-plugin
module.exports = {"headline":"headline-m__headline__ieh5X"};